export var ImageOptionsKey={DEFAULT:'default',UPLOAD:'uploadlocal',FACEBOOKIMPORT:'fbimport'};